import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider } from 'antd';
import esES from 'antd/locale/es_ES';
import './index.css';
import App from './App';
import { buildTheme } from './theme';
import { ThemeProvider, useThemeMode } from './contexts/ThemeContext';

// El ConfigProvider se alimenta del tema resuelto por el contexto (claro/oscuro).
const ThemedConfigProvider = ({ children }) => {
  const { resolved } = useThemeMode();
  return (
    <ConfigProvider theme={buildTheme(resolved)} locale={esES}>
      {children}
    </ConfigProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <ThemedConfigProvider>
        <App />
      </ThemedConfigProvider>
    </ThemeProvider>
  </React.StrictMode>
);
